import Fmt from './Fmt';
import * as _ from 'lodash';

class CsvGenerator {
    constructor(clientData) {
        this._clientData = clientData;
    }

    getCsvString() {

        if (this._clientData.length === 0) {
            return "";
        }

        let csv = this._getRow(this._clientData[0], true);

        csv += this._clientData.map(cd => {
            return this._getRow(cd);
        }).join("");

        return csv;
    }

    _getRow(cd, header) {
        let values = [];

        values.push(header ? "CSM" : cd.account.csm);
        values.push(header ? "Client" : cd.account.client_name);
        values.push(header ? "Client ID" : cd.account.client_id);
        values.push(header ? "ECom" : cd.account.has_ecom);
        values.push(header ? "Health Score" : cd.health_score.score);
        values.push(header ? "Prorated ARR" : Fmt.num(cd.account.arr_prorated, 2));
        values.push(header ? "Total ARR" : Fmt.num(cd.account.arr_total, 2));
        values.push(header ? "Start Date" : Fmt.dt(cd.account.start_date));
        values.push(header ? "Days Since Start" : Fmt.num(cd.account.days_since_start));
        values.push(header ? "Renewal Date" : Fmt.dt(cd.account.renewal_date));
        values.push(header ? "Renewal Stage" : cd.account.renewal_stage);
        values.push(header ? "Red Account" : cd.account.is_red_account);
        values.push(header ? "Red Account Trigger" : cd.account.red_account_trigger);
        values.push(header ? "Likely API Consumer" : cd.visits.likely_api_consumer);

        values.push(header ? "Catalogs Connected" : cd.product_catalogs.catalogs.length);

        let revConnected = "false";

        if (!header) {
            if (cd.revenue_connections.connections.length > 0) {
                if (cd.revenue_connections.has_valid_connection) {
                    revConnected = "true";
                } else {
                    revConnected = "invalid"
                }
            }
        }

        values.push(header ? "Revenue Connected" : revConnected);

        values.push(header ? "Active Users" : cd.active_users.count);

        const sessions = header ? null : cd.app_sessions.weekly;
        values.push(header ? "App Sessions Current 4 Weeks" : Fmt.num(sessions.four_week_current));
        values.push(header ? "App Sessions Previous 4 Weeks" : Fmt.num(sessions.four_week_previous));

        const tags = header ? null : cd.tagged_items.weekly;
        values.push(header ? "Tagged Items Current 4 Weeks" : Fmt.num(tags.four_week_current));
        values.push(header ? "Tagged Items Previous 4 Weeks" : Fmt.num(tags.four_week_previous));

        const touchpoints = ["all", "fanreel", "like2buy", "showroom", "reveal"];

        _.forEach(touchpoints, tp => {
            const tpName = cd.visits[tp].name;
            values.push(header ? `${tpName} Visits Current 4 Weeks` : cd.visits[tp].weekly.four_week_current);
            values.push(header ? `${tpName} Visits Previous 4 Weeks` : cd.visits[tp].weekly.four_week_previous);
        });

        _.forEach(touchpoints, tp => {

           const tpName = cd.visits[tp].name;
           const tpValues = cd.visits[tp].weekly.raw_data.slice().reverse();

           for (let i = 0; i < 12; i++) {
               const weeks = i === 0 ? "week" : "weeks";
               values.push(header ? `${tpName} Visits ${i + 1} ${weeks} ago` : Fmt.num(tpValues[i].visits));
           }
        });

        return "\"" + values.join("\",\"") + "\"\r\n";
    }
}

export default CsvGenerator;


// WEBPACK FOOTER //
// ./src/CsvGenerator.js